'use client';

import Banner from '@/joystagram-components/components/consumer/Banner';
import FabricFilter from '@/joystagram-components/components/consumer/fabric-filter';

const bannerConfig = {
  imageComponent: {
    size: 'Full Width',
  },
  textContentSection: {
    textColor: 'white',
    textOrientation: 'Left',
    aboveTitle: {
      text: '',
      tag: 'h2',
      size: 'text-base',
    },
    title: {
      text: 'Meet our fabrics',
      tag: 'h1',
      size: 'text-2xl',
    },
    belowTitle: {
      text:
        'Browse our selection of colorful and neutral fabrics and leathers and make your piece your own. Or, order a free swatch kit to see and feel all our fabrics in person!',
      tag: 'h2',
      size: 'text-base',
    },
  },
  videoBlock: {
    enabled: {
      value: 'Disabled',
    },
  },
  bannerSection: {
    image: {
      desktopSrc:
        'https://joybird2.imgix.net/user-uploads-staging/webimage-4CABDBD3-1B80-4A1A-884BF0B4FB4F9404.jpg',
      mobileSrc:
        'https://joybird2.imgix.net/user-uploads-staging/webimage-4CABDBD3-1B80-4A1A-884BF0B4FB4F9404.jpg',
      showOverlay: 30,
      minHeight: { value: '412px' },
    },
    video: {
      videoLink: '',
      videoTitle: '',
      videoImageSrc: '',
    },
  },
  buttonConfig: {
    isMultipleBtn: 'False',
    maxButtonCount: 1,
  },
  buttonSection: {
    button1: {
      selected: 'CTAButton',
      ctaLink: {
        linkTo: '/',
        content: 'Shop Now',
        style: 'solid-button',
        color: 'brand',
        textColor: '#ffffff',
        activeColor: '#cccccc',
        hoverColor: '#dddddd',
        borderColor: '#000000',
      },
      ctaButton: {
        type: 'SwatchRequestForm',
        content: 'Order free swatches',
        style: 'solid-button',
        color: 'brand',
        textColor: '#ffffff',
        activeColor: '#cccccc',
        hoverColor: '#dddddd',
        borderColor: '#000000',
      },
    },
  },
};

const SwatchesPage = () => {
  return (
    <>
      <Banner config={bannerConfig} />
      <FabricFilter isAdmin={false} />
    </>
  );
};

export default SwatchesPage;
